/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

export interface GetTile$Params {
   providerId: string;
   type: number;
   weatherType: number;
   date: string;
   z: number;
   x: number;
   y: number;
}

export function getTile(
   http: HttpClient,
   rootUrl: string,
   params: GetTile$Params,
   context?: HttpContext
): Observable<StrictHttpResponse<Blob>> {
   const rb = new RequestBuilder(rootUrl, getTile.PATH, 'get');
   if (params) {
      rb.path('providerId', params.providerId, {});
      rb.path('type', params.type, {});
      rb.path('weatherType', params.weatherType, {});
      rb.path('date', params.date, {});
      rb.path('z', params.z, {});
      rb.path('x', params.x, {});
      rb.path('y', params.y, {});
   }

   return http.request(rb.build({ responseType: 'blob', accept: 'application/octet-stream', context })).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
         return r as StrictHttpResponse<Blob>;
      })
   );
}

getTile.PATH = '/api/weather/tiles/{providerId}/{type}/{weatherType}/{date}/{z}/{x}/{y}';
